import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { fetchTemples } from "../redux/templeSlice";
import { generatePlan } from "../redux/planSlice";

function PlanVisit(){

const dispatch=useDispatch();

const { temples }=
useSelector(state=>state.temples);

const { plan,loading }=
useSelector(state=>state.plan);

const [selectedTemples,setSelectedTemples]=useState([]);

const [budget,setBudget]=useState("");

const [priority,setPriority]=
useState("Spiritual");

useEffect(()=>{
 dispatch(fetchTemples());
},[dispatch]);

const toggleTemple=(id)=>{

if(selectedTemples.includes(id)){

setSelectedTemples(
selectedTemples.filter(t=>t!==id)
);

}else{

setSelectedTemples([
...selectedTemples,
id
]);

}

};

const createPlan=()=>{

dispatch(generatePlan({

templeIds:selectedTemples,
budget,
priority

}));

};

return(

<div className="container mt-4 mb-5">

<h2 className="text-center mb-4">
 AI Temple Visit Planner
</h2>

<div className="card p-4 shadow mb-4">

<h5>Select Temples</h5>

<div className="row">

{temples.map(t=>(

<div key={t._id} className="col-md-4">

<div className="form-check">

<input
type="checkbox"
className="form-check-input"
onChange={()=>toggleTemple(t._id)}
/>

<label className="form-check-label">
{t.name}
</label>

</div>

</div>

))}

</div>

</div>


<div className="card p-4 shadow mb-4">

<div className="row">

<div className="col-md-6">

<label>Budget</label>

<input
type="number"
className="form-control"
value={budget}
onChange={(e)=>setBudget(e.target.value)}
/>

</div>


<div className="col-md-6">

<label>Priority</label>

<select
className="form-control"
value={priority}
onChange={(e)=>setPriority(e.target.value)}
>

<option>Spiritual Experience</option>
<option>Short Visit</option>
<option>Family Friendly</option>
<option>Festival Focused</option>
<option>Budget Friendly</option>

</select>

</div>

</div>

</div>


<div className="text-center">

<button
className="btn btn-primary btn-lg"
onClick={createPlan}
>

Generate AI Plan

</button>

</div>


{loading &&(

<div className="text-center mt-4">

<div className="spinner-border"/>

</div>

)}


{plan &&(

<div className="card p-4 shadow mt-4">

<h4 className="text-center">
AI Travel Plan
</h4>

<pre style={{whiteSpace:"pre-wrap"}}>
{plan}
</pre>

</div>

)}

</div>

);

}

export default PlanVisit;